import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Font,
    PDFViewer,
    Image,
} from "@react-pdf/renderer";
import { useEvent } from "../context/eventContext";
import { getSelectedElement, myTimestampToDate } from "../utils/ui_utils";
import { format, isSameDay } from "date-fns";
import { getCross } from "../definitions/cow";
import { logopath } from "../definitions/anafilogo";
import { getFilteredList } from "../definitions/match";

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});


// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: "#fff",
        color: "black",
        margin: 0,
        fontSize: 10,
        padding: 10,
        paddingBottom: 30
    },
    section: {
        margin: 10,
        padding: 10,
    },
    header: {
        padding: 10,
        marginBottom: 5,
        flexDirection: "row",
        flexWrap: "wrap",
        borderBottom: '1px solid #3D79D1',
        justifyContent: "center",
        fontWeight: 'bold',
        verticalAlign: "center",
    },
    title: {
        fontSize: '14px',
        backgroundColor: '#3D79D1',
        padding: 2,
        color: 'white',
        fontWeight: 'bold',
        textAlign: "center"
    },
    subtitle: {
        borderTop: '1px solid #3D79D1',
        borderBottom: '1px solid #3D79D1',
        fontSize: '14px',
        padding: 2,
        marginTop: 5,
        marginBottom: 10,
        fontWeight: 'bold',
    },
    catalog: {
        textAlign: 'right',
        fontFamily: "Helvetica-Bold",
        width: '20px',
    },
    position: {
        textAlign: 'center',
        fontFamily: "Helvetica-Bold",
        borderRadius: 10,
        backgroundColor: '#999',
        color: '#fff',
        width: '20px',
    },
    judge_row: {
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        fontWeight: 'bold',
        verticalAlign: "center",
    },
    judge_container: {
        alignItems: "right",
        textAlign: 'center',
        width: '30%',
        marginTop: 20,
    },
    highlight: {
        color: 'black',
        fontFamily: "Helvetica-Bold",
    },
    image: {
        height: 20,
        marginRight: 10
    },
    cow_subrow_container: {
        flexDirection: "row",
        flexWrap: "wrap",
        margin: 0,
        padding: 0,
        alignItems: "center", // Aligns text vertically in the center
    },
    cow_spacer: {
        borderBottom: '1px solid #aaa',
        paddingBottom: 18,
    },
    cow_container_big: {
        flexDirection: "column",
        flexWrap: "wrap",
        margin: 0,
        padding: 0,
    },
    cow_container_border: {
        marginBottom: 1,
        marginTop: 1,
    },
    cowname: {
        fontFamily: "Helvetica-Bold"
    },
    label: {
        fontSize: 8
    },
    subsection: {
        margin: 10,
        padding: 10,
    },
    firstrow: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        fontSize: '40px',
        fontFamily: "Helvetica-Bold"
    },
    section_title: {
        borderBottom: '1px solid black',
        textAlign: 'center',
        fontSize: '10px',
        color: '#3D79D1',
        paddingBottom: 2,
        marginTop: 2
    },
    footer: {
        borderTop: '1px solid #3D79D1',
        textAlign: 'center',
        position: 'absolute',
        fontSize: 10,
        bottom: 10,
        left: 10,
        right: 10,
        paddingTop: 5,
        textAlign: 'center',
        color: 'grey',

    },
    viewer: {
        width: window.innerWidth - 100, //the pdf viewer will take up all of the width and height
        height: window.innerHeight - 200,
    },
});
const c_type_dict = {
    prering: 'default',
    prering_light: 'light',
    postpresence: 'light',
    postresult: 'postresult',
    result: 'result',
    summaryresult: 'result'
}

const CowlistSection = ({ selEvent, cow_list, p_type, offset }) => {
    const c_type = c_type_dict[p_type]
    console.log("COW LIST", cow_list)
    return (
        cow_list.map((c, k) => (
            <OneCow c_type={c_type} key={offset ? k - offset : k} cow={c} index={k} selEvent={selEvent} />
        ))
    )
}

const CowlistPdf = ({ doc_data, p_type, is_multi }) => {
    const { selEvent } = useEvent()

    return (
        <CowlistPdfMulti doc_data={[doc_data]} p_type={p_type} page_split={true} />
    )
    if (p_type === 'prering') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Gestione ring - ${doc_data.section_title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"} >
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} />
                        <View style={styles.title}><Text>Gestione Prering</Text></View>
                        <View style={styles.subtitle}><Text>{doc_data.section_title}</Text></View>
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )
    } else if (p_type === 'prering_light') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Gestione prering - ${doc_data.section_title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"}>
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>Gestione Prering</Text></View>
                        <View style={styles.subtitle}><Text>{doc_data.section_title}</Text></View>
                        {doc_data.cow_list?.map((c, k) => (
                            <OneCow c_type={"light"} key={k} cow={c} index={k} selEvent={selEvent} />
                        ))}
                        <View style={{ marginTop: 10 }}><Text>Totale soggetti:   {doc_data.cow_list.length}</Text></View>
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )
    } else if (p_type === 'postpresence') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Report presenze - ${doc_data.section_title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"}>
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>Report Presenze</Text></View>
                        <View style={styles.subtitle}><Text>{doc_data.section_title}</Text></View>
                        <View style={styles.section_title}><Text>Soggetti presenti in ring</Text></View>
                        {console.log(" PDF COW LIST", doc_data.cow_list)}
                        {doc_data.cow_list?.filter(c => c.is_in_ring).length > 0 &&
                            <>
                                {doc_data.cow_list.filter(c => c.is_in_ring).map((c, k) => (
                                    <OneCow c_type={"light"} key={k} cow={c} index={k} selEvent={selEvent} />
                                ))}
                            </>}
                        {!doc_data.cow_list?.filter(c => !c.is_in_ring).length > 0 &&
                            <>
                                <View style={styles.section_title}><Text>Soggetti assenti</Text></View>
                                {doc_data.cow_list.filter(c => !c.is_in_ring).map((c, k) => (
                                    <OneCow c_type={"light"} key={k} cow={c} index={k} selEvent={selEvent} />
                                ))}
                            </>}
                        <View style={styles.judge_row}>

                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Totale soggetti</Text>
                                </View>
                                <Text style={styles.highlight}> {doc_data.cow_list.length}</Text>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>presenti in ring</Text>
                                </View>
                                <Text style={styles.highlight}> {doc_data.cow_list.filter(f => f.is_in_ring).length}</Text>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>assenti</Text>
                                </View>
                                <Text style={styles.highlight}> {doc_data.cow_list.filter(f => !f.is_in_ring).length}</Text>
                            </View>
                        </View>
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )
    } else if (p_type === 'postresult') {
        const filtered_list = getFilteredList(doc_data.id, doc_data.result_list, doc_data.cow_list)

        console.log("FILTERED LIST", filtered_list, doc_data.result_list)
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Convalida risultati - ${doc_data.section_title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"}>

                    <Page size="A4" style={styles.page}>
                        {filtered_list.map((f, fk) => (
                            <View key={fk}>
                                {fk === 0 && <>
                                    <PageHeader selEvent={selEvent} fixed />
                                    <View style={styles.title}><Text>Convalida risultati</Text></View>
                                    <View style={styles.subtitle}><Text>{doc_data.section_title}</Text></View>
                                </>}
                                <View style={styles.title}><Text>{f.name} {f.subname}</Text></View>
                                {console.log("AWRARFDD VALUE", f)}
                                {f.cow_list.filter(c => c.cow && c.cow.id).map((c, k) => (
                                    <OneCow c_type={"postresult"} key={k} cow={c} index={k} selEvent={selEvent} award_value={f.award_value} />
                                ))}
                                {!doc_data.other_options.hide_not_qualified && f.no_match_cow_list && f.no_match_cow_list.length > 0 &&
                                    <>
                                        <View style={{ ...styles.subtitle, fontSize: '10px', textAlign: 'center', marginTop: 15 }}><Text>Soggetti non classificati</Text></View>
                                        {f.no_match_cow_list.map((c, k) => (
                                            <OneCow c_type={"postresult"} key={k} index={k - 30} cow={{ cow: c }} selEvent={selEvent} />
                                        ))}
                                        <View style={{ fontSize: '10px', textAlign: 'center', marginBottom: 15 }}></View>
                                    </>
                                }
                                {f.cow_list.length === 0 && (!f.no_match_cow_list || f.no_match_cow_list.length === 0) &&
                                    <View>
                                        <Text > nessun soggetto classificato</Text>
                                    </View>}
                            </View>
                        ))}
                        <View style={styles.judge_row}>

                            <View style={styles.judge_container}>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Giudice ufficiale</Text>
                                </View>
                                <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                            </View>
                        </View>
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>

        )


    } else if (p_type === 'result') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Gestione ring - ${doc_data.section_title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"} >
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>Gestione Giudizi</Text></View>
                        <View style={styles.subtitle}><Text>{doc_data.section_title}</Text></View>
                        {doc_data.cow_list.map((c, k) => (
                            <OneCow c_type={"result"} key={k} cow={c} index={k} selEvent={selEvent} />
                        ))}
                        <View style={styles.judge_row}>

                            <View style={styles.judge_container}>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Giudice ufficiale</Text>
                                </View>
                                <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                            </View>
                        </View>
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )
    } else if (p_type === 'summaryresult') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Riepilogo capi - ${doc_data.section_title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"} >
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>Riepilogo capi</Text></View>
                        <View style={styles.subtitle}><Text>{doc_data.section_title}</Text></View>
                        {doc_data.cow_list.map((c, k) => (
                            <OneCow c_type={"result"} key={k} cow={c} index={k} selEvent={selEvent} award_value={doc_data.award_value} />
                        ))}
                        <View style={styles.judge_row}>
                            <View style={styles.judge_container}>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Giudice ufficiale</Text>
                                </View>
                                <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                            </View>
                        </View>
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )
    }


}





export const CowlistPdfMulti = ({ doc_data, p_type, page_split }) => {
    const { selEvent } = useEvent()
    let doc_title = `${selEvent.event_name} - Gestione ring`
    let title = ''
    let PageContent = <></>
    if (p_type === 'prering') {
        doc_title = `${selEvent.event_name} - Gestione ring`
        title = 'Gestione Ring'
        if (page_split) {
            PageContent = () => (<>{doc_data.map((d, k) => (
                <Page key={k} size="A4" style={styles.page}>
                    <PageHeader selEvent={selEvent} />
                    <View style={styles.title}><Text>{title}</Text></View>
                    <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                    <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                    <PageFooter />
                </Page>
            ))}</>)

        } else {
            PageContent = () => (
                <>
                    <View style={styles.title}><Text>{title}</Text></View>
                    {doc_data.map((d, k) => (
                        <>
                            <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                            <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                        </>
                    ))}
                </>)
        }
    } else if (p_type === 'prering_light') {
        doc_title = `${selEvent.event_name} - Gestione prering`
        title = 'Gestione prering'
        if (page_split) {
            PageContent = () => (<>
                {doc_data.map((d, k) => (
                    <Page key={k} size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>{title}</Text></View>
                        <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                        <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                        <View style={{ marginTop: 10 }}><Text>Totale soggetti:   {d.cow_list.length}</Text></View>
                        <PageFooter />
                    </Page>
                ))}
            </>)

        } else {
            PageContent = () => (<>
                <View style={styles.title}><Text>{title}</Text></View>
                {doc_data.map((d, k) => (
                    <>
                        <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                        <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                        <View style={{ marginTop: 10 }}><Text>Totale soggetti:   {d.cow_list.length}</Text></View>
                    </>
                ))}
            </>)

        }
    } else if (p_type === 'postpresence') {
        doc_title = `${selEvent.event_name} - Report presenze`
        title = 'Report presenze'
        if (page_split) {
            PageContent = () => (<>
                {doc_data.map((d, k) => (
                    <Page keyy={k} size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>{title}</Text></View>
                        <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                        <View style={styles.section_title}><Text>Soggetti presenti in ring</Text></View>
                        <CowlistSection selEvent={selEvent} cow_list={d.cow_list.filter(c => c.is_in_ring&& !c.squalified)} p_type={p_type} />
                        {d.cow_list?.filter(c => !c.is_in_ring || c.squalified).length > 0 &&
                            <>
                                <View style={styles.section_title}><Text>Soggetti assenti</Text></View>
                                <CowlistSection selEvent={selEvent} cow_list={d.cow_list.filter(c => !c.is_in_ring || c.squalified)} p_type={p_type} />
                            </>}
                        <View style={styles.judge_row} wrap={false}>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Totale soggetti</Text>
                                </View>
                                <Text style={styles.highlight}> {d.cow_list.length}</Text>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>presenti in ring</Text>
                                </View>
                                <Text style={styles.highlight}> {d.cow_list.filter(c => c.is_in_ring).length}</Text>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>assenti</Text>
                                </View>
                                <Text style={styles.highlight}> {d.cow_list.filter(c => !c.is_in_ring|| c.squalified).length}</Text>
                            </View>
                        </View>
                        <PageFooter />
                    </Page>
                ))}
            </>)

        } else {
            PageContent = () => (<>
                <View style={styles.title}><Text>{title}</Text></View>
                {doc_data.map((d, k) => (
                    <>
                        <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                        <View style={styles.section_title}><Text>Soggetti presenti in ring</Text></View>
                        <CowlistSection selEvent={selEvent} cow_list={d.cow_list.filter(c => c.is_in_ring && !c.squalified)} p_type={p_type} />
                        {d.cow_list?.filter(c => !c.is_in_ring || c.squalified).length > 0 &&
                            <>
                                <View style={styles.section_title}><Text>Soggetti assenti</Text></View>
                                <CowlistSection selEvent={selEvent} cow_list={d.cow_list.filter(c => !c.is_in_ring || c.squalified)} p_type={p_type} />
                            </>}
                        <View style={styles.judge_row} wrap={false}>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Totale soggetti</Text>
                                </View>
                                <Text style={styles.highlight}> {d.cow_list.length}</Text>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>presenti in ring</Text>
                                </View>
                                <Text style={styles.highlight}> {d.cow_list.filter(c => c.is_in_ring).length}</Text>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>assenti</Text>
                                </View>
                                <Text style={styles.highlight}> {d.cow_list.filter(c => !c.is_in_ring || c.squalified).length}</Text>
                            </View>
                        </View>
                    </>
                ))}
            </>)

        }
    } else if (p_type === 'postresult') {
        doc_title = `${selEvent.event_name} - Convalida risultati`
        title = 'Convalida risultati'
        console.log("other options", doc_data.other_options)
        console.log("DEBUG PRINT DATA" )
        if (page_split) {
            PageContent = () => (<>
                {doc_data.map((d, k) => (
                    <Page key={k} size="A4" style={styles.page}>
                        {getFilteredList(d.id, d.result_list, d.cow_list).map((f, fk) => (
                            <View key={fk} wrap={f.cow_list.length>1}>
                                {fk === 0 && <>
                                    <PageHeader selEvent={selEvent} fixed />
                                    <View style={styles.title}><Text>{title}</Text></View>
                                    <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                                </>}
                                <View style={styles.title} wrap={false}><Text>{f.name} {f.subname}</Text></View>
                                {console.log("D.... award COW LIST", f.cow_list)}
                                <CowlistSection selEvent={selEvent} cow_list={f.cow_list.map(ff => {
                                    return {...ff, 
                                        cow:  ff.cow? getSelectedElement(ff.cow.id, d.cow_list, 'id'): undefined}
                                })} p_type={p_type} />
                                {!doc_data.other_options?.hide_not_qualified && f.no_match_cow_list && f.no_match_cow_list.length > 0 &&
                                    <>
                                        <View style={{ ...styles.subtitle, fontSize: '10px', textAlign: 'center', marginTop: 15 }}><Text>Soggetti non classificati</Text></View>
                                        <CowlistSection selEvent={selEvent} cow_list={f.no_match_cow_list.map(ff => {
                                    return {...ff, 
                                        cow: ff.cow? getSelectedElement(ff.cow.id, d.cow_list, 'id'): undefined}
                                }).map(c => { return { cow: c } })} p_type={p_type} offset={40} />
                                        <View style={{ fontSize: '10px', textAlign: 'center', marginBottom: 15 }}></View>
                                    </>
                                }
                                {f.cow_list.length === 0 && (!f.no_match_cow_list || f.no_match_cow_list.length === 0) &&
                                    <View>
                                        <Text > nessun soggetto classificato</Text>
                                    </View>}
                            </View>
                        ))}
                        <View style={styles.judge_row} wrap={false}>

                            <View style={styles.judge_container}>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Giudice ufficiale</Text>
                                </View>
                                <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                            </View>
                        </View>
                        <PageFooter />
                    </Page>
                ))}
            </>)

        } else {
            PageContent = () => (<>
                <View style={styles.title}><Text>{title}</Text></View>
                {doc_data.map((d, k) => (
                    <>
                        {getFilteredList(d.id, d.result_list, d.cow_list).map((f, fk) => (
                            <View key={fk} wrap={f.cow_list.length>0}>
                                {fk === 0 && <>
                                    <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                                </>}
                                <View style={styles.title}><Text>{f.name} {f.subname}</Text></View>
                                <CowlistSection selEvent={selEvent} cow_list={f.cow_list.map(ff => {
                                    return {...ff, 
                                        cow: ff.cow? getSelectedElement(ff.cow.id, d.cow_list, 'id'): undefined,}
                                }).filter(c => c.cow && c.cow.id)} p_type={p_type} />
                                {!doc_data.other_options?.hide_not_qualified && f.no_match_cow_list && f.no_match_cow_list.length > 0 &&
                                    <>
                                        <View style={{ ...styles.subtitle, fontSize: '10px', textAlign: 'center', marginTop: 15 }}><Text>Soggetti non classificati</Text></View>
                                        <CowlistSection selEvent={selEvent} cow_list={f.no_match_cow_list.map(c => { return { cow: c } })} p_type={p_type} offset={40} />
                                        <View style={{ fontSize: '10px', textAlign: 'center', marginBottom: 15 }}></View>
                                    </>
                                }
                                {f.cow_list.length === 0 && (!f.no_match_cow_list || f.no_match_cow_list.length === 0) &&
                                    <View>
                                        <Text > nessun soggetto classificato</Text>
                                    </View>}
                            </View>
                        ))}
                    </>
                ))}
                <View style={styles.judge_row} wrap={false}>

                    <View style={styles.judge_container}>
                    </View>
                    <View style={styles.judge_container}>
                        <View>
                            <Text>Giudice ufficiale</Text>
                        </View>
                        <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                        <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                    </View>
                </View>
            </>)

        }


    } else if (p_type === 'result') {
        doc_title = `${selEvent.event_name} - Gestione giudizi`
        title = "gestione giudizi"
        if (page_split) {
            PageContent = () => (<>
                {doc_data.map((d, k) => (
                    <Page key={k} size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>{title}</Text></View>
                        <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                        <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                        <View style={styles.judge_row} wrap={false}>

                            <View style={styles.judge_container}>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Giudice ufficiale</Text>
                                </View>
                                <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                            </View>
                        </View>
                        <PageFooter />
                    </Page>
                ))}
            </>)

        } else {
            PageContent = () => (<>
                <View style={styles.title}><Text>{title}</Text></View>
                {doc_data.map((d, k) => (
                    <>
                        <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                        <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                        <View style={styles.judge_row} wrap={false}>

                            <View style={styles.judge_container}>
                            </View>
                            <View style={styles.judge_container}>
                                <View>
                                    <Text>Giudice ufficiale</Text>
                                </View>
                                <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                            </View>
                        </View>
                    </>
                ))}
            </>)

        }
    } else if (p_type === 'summaryresult') {
        console.log("PDF DATA summary", doc_data)
        doc_title = `${selEvent.event_name} - Riepilogo capi`
        title = "riepilogo capi"
        if (page_split) {
            PageContent = () => (
                <>
                    {doc_data.map((d, k) => (
                        <Page key={k} size="A4" style={styles.page}>
                            <PageHeader selEvent={selEvent} fixed />
                            <View style={styles.title}><Text>{title}</Text></View>
                            <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                            <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                            <View style={styles.judge_row} wrap={false}>
                                <View style={styles.judge_container}>
                                </View>
                                <View style={styles.judge_container}>
                                    <View>
                                        <Text>Giudice ufficiale</Text>
                                    </View>
                                    <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                    <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                                </View>
                            </View>
                            <PageFooter />
                        </Page>
                    ))}
                </>
            )

        } else {
            PageContent = () => (
                <>
                    <View style={styles.title}><Text>{title}</Text></View>
                    {doc_data.map((d, k) => (
                        <>
                            <View style={styles.subtitle}><Text>{d.section_title}</Text></View>
                            <CowlistSection selEvent={selEvent} cow_list={d.cow_list} p_type={p_type} />
                            <View style={styles.judge_row} wrap={false}>
                                <View style={styles.judge_container}>
                                </View>
                                <View style={styles.judge_container}>
                                    <View>
                                        <Text>Giudice ufficiale</Text>
                                    </View>
                                    <Text style={styles.highlight}>{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                                    <Text style={{ marginTop: 10, color: 'grey' }}>_________________________</Text>
                                </View>
                            </View>
                        </>
                    ))}
                </>
            )

        }
    }
    //....end formatting
    if (page_split) {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={doc_title} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"} >
                    <PageContent />
                </Document>
            </PDFViewer>
        )

    } else {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={doc_title} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"} >
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} />
                        <PageContent />
                        <PageFooter />
                    </Page>
                </Document>
            </PDFViewer>
        )
    }
}




const PageFooter = () => {
    return (
        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
        )} fixed />

    )
}



const PageHeader = ({ selEvent }) => {
    const ev_start = myTimestampToDate(selEvent.event_start)
    const ev_end = myTimestampToDate(selEvent.event_end)
    let ev_date = format(ev_start, 'dd/MM/yyyy')
    if (!isSameDay(ev_start, ev_end)) {
        ev_date = `${format(ev_start, 'dd')}-${format(ev_end, 'dd /MM/yyyy')}`
    }

    return (

        <View style={styles.header} fixed>
            {selEvent.document_show_logo &&
                <Image
                    style={styles.image}
                    src={logopath}
                />
            }
            <View style={{ flex: 2, fontFamily: "Helvetica-Bold" }}>
                <Text>
                    {selEvent.event_name}
                </Text>
            </View>
            <View style={{ flex: 2 }}>
                <Text>
                    {selEvent.location?.name}
                </Text>
            </View>
            <View style={{ flex: 1 }}>
                <Text>
                    {ev_date}
                </Text>
            </View>
            {selEvent.document_show_customlogo && selEvent.logo &&
                <Image
                    style={styles.image}
                    src={selEvent.logo}
                />
            }

        </View>
    )
}

const OneCow = ({ cow, c_type, index, award_value }) => {


    let property_string = cow.property?.name || ''
    console.log("COW PROPERTY DEBUG", cow)
    if (cow.coproperty && cow.coproperty.length > 0) {
        property_string = property_string + " (" + cow.coproperty + ") "
    }
    if (cow.property && cow.property.provincia && cow.property.provincia.length > 0) {

        property_string = property_string + " - " + cow.property.provincia
    }
    let catalog_id = cow.catalog_id || '___'
    if (c_type === 'light') {

        return (

            <View style={[styles.cow_subrow_container, styles.cow_spacer, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>

                <View style={{ flex: 1, alignSelf: 'flex-start' }}>

                    <Text>
                        <Text style={{ ...styles.cowname, width: '10px' }}>{catalog_id}</Text>
                        {cow.serial}&nbsp;
                        <Text style={styles.cowname}>{cow.name?.trim()}</Text>
                        <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                        <Text style={{ margin: 10, fontSize: '8px', }}>
                            &nbsp;{property_string}
                        </Text>
                    </Text>
                </View>
            </View>
        )

    } else if (c_type === 'result') {
        return (

            <View style={[styles.cow_subrow_container, styles.cow_spacer, { paddingTop: 2, backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>

                <View style={{ flex: 0.9, alignSelf: 'flex-start' }}>

                    <Text>
                        <Text style={{ ...styles.cowname, width: '10px' }}>{catalog_id}</Text> {cow.serial}
                        <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                        <Text style={{ ...styles.label }}>, parti:</Text> {cow.birth}
                        {award_value ?
                            <>
                                <Text style={{ ...styles.label }}>{award_value.name}:</Text> {cow[award_value.value]}
                            </> : <Text></Text>
                        }
                        <Text style={{ margin: 10, color: 'grey', textAlign: 'right', flexFlow: "end" }}>
                        </Text>
                    </Text>
                </View>
                <View style={{ flex: 0.1, alignSelf: 'flex-end' }}>
                    <Text style={{ marginLeft: 10, }}>
                        &nbsp;&nbsp;n°
                    </Text>
                </View>
            </View>
        )
    } else if (c_type === 'postresult') {
        //        console.log("RES COW", cow)

        const RADIUS = '50px'
        property_string = cow.cow.property?.name || ''
        if (cow.cow.property && cow.cow.property.provincia && cow.cow.property.provincia.length > 0) {
            property_string = property_string + " - " + cow.cow.property.provincia
        }
        let cowman_string = cow.cow.cowman?.name || ''
        if (cow.cow.cowman && cow.cow.cowman.provincia && cow.cow.cowman.provincia.length > 0) {
            cowman_string = cowman_string + " - " + cow.cow.cowman.provincia
        }
        return (
            <View style={[styles.cow_spacer, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>
                <View style={styles.cow_subrow_container}>

                    <View style={{ flex: 0.3 }}>
                        {index >= 0 &&
                            <Text style={styles.position}>{index + 1}</Text>
                        }
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                        <Text style={styles.catalog}>{cow.cow.catalog_id}</Text>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            {cow.cow.serial} <Text style={styles.cowname}>{cow.cow.name?.trim()}</Text>
                            <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.cow.birthdate), 'dd/MM/yyyy')}
                            <Text style={{ ...styles.label }}>, parti:</Text> {cow.cow.birth}
                        </Text>
                    </View>
                </View>
                <View style={styles.cow_subrow_container}>
                    <View style={{ flex: 0.3 }}>
                        {index >= 0 &&
                            <Text >&nbsp;</Text>
                        }
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            <Text style={{ ...styles.label }}>prop:&nbsp;</Text>
                            {property_string}&nbsp;&nbsp;
                            <Text style={{ fontSize: '8px', marginLeft: 10 }}>
                                {cow.cow.coproperty}
                            </Text>
                        </Text>
                    </View>
                </View>
{/*                 <View style={styles.cow_subrow_container}>
                    <View style={{ flex: 0.3 }}>
                        {index >= 0 &&
                            <Text >&nbsp;

                            </Text>
                        }
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                    </View>
                    {cowman_string.length > 0 ?
                        <View style={{ flex: 7 }}>
                            <Text>
                                <Text style={{ ...styles.label }}>all:&nbsp;</Text>
                                {cowman_string}
                            </Text>
                        </View>
                        : <Text></Text>}
                </View> */}
                {award_value ?
                    <View style={styles.cow_subrow_container}>
                        <View style={{ flex: 0.3 }}>
                            {index >= 0 &&
                                <Text >&nbsp;

                                </Text>
                            }
                        </View>
                        <Text style={{ ...styles.label }}>{award_value.name}:</Text>
                        <Text style={{ fontSize: '8px', marginLeft: 10 }}>
                            {cow[award_value.value]}
                        </Text>
                        <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                        </View>
                    </View>
                    : <Text></Text>}
            </View>
        )

    } else {
        return (
            <View style={[styles.cow_spacer, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>

                <View style={[styles.cow_subrow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                        <Text style={{ ...styles.cowname, width: '10px' }}>{catalog_id}</Text>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            {cow.serial}&nbsp;
                            <Text style={styles.cowname}>{cow.name?.trim()}</Text>
                            <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                            <Text style={{ ...styles.label }}>, parti:</Text> {cow.birth}
                        </Text>
                    </View>
                </View>

                <View style={[styles.cow_subrow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                        <Text style={{ ...styles.cowname, width: '10px' }}>&nbsp;</Text>
                    </View>
                    <View style={{ flex: 4 }}>
                        <Text>
                            &nbsp;{getCross(cow)}
                        </Text>
                    </View>
                    <View style={{ flex: 0.6 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> pft: </Text>
                            {cow.pft},
                        </Text>
                    </View>
                    <View style={{ flex: 0.6 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> ies: </Text>
                            {cow.ies},
                        </Text>
                    </View>
                    <View style={{ flex: 0.7 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> ics-pr: </Text>
                            {cow.ics_pr},
                        </Text>
                    </View>
                    <View style={{ flex: 0.7 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> kg prot: </Text>
                            {cow.kg_protein_index},
                        </Text>
                    </View>
                    <View style={{ flex: 1 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> KgLatGgVita: </Text>
                            {cow.milk_gg_life}
                        </Text>
                    </View>
                </View>
                <View style={[styles.cow_subrow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                        <Text style={{ ...styles.cowname, width: '10px' }}>&nbsp;</Text>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text style={{ textTransform: 'capitalize' }}>
                            {titleCase(property_string)}
                        </Text>
                    </View>
                </View>
            </View>
        )

        return (

            <View style={[styles.cow_subrow_container_border, { backgroundColor: index % 2 === 0 ? '#eee' : 'white' }]} wrap={false}>
                <Text style={{ border: '1px solid black', alignItems: 'flex-start', textAlign: 'left' }}>
                    <Text style={styles.catalog}>{catalog_id}</Text> {cow.serial} <Text style={styles.cowname}>{cow.name?.trim()}</Text>, {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}<Text style={{ ...styles.label }}>, parti:</Text> {cow.birth}
                </Text>
                <Text style={{ marginLeft: 17 }}>
                    {property_string}
                </Text>
                <Text style={{ marginLeft: 17 }}>
                    {getCross(cow)}
                </Text>
            </View>
        )
    }

}

function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}


export default CowlistPdf;